import UgcBackgroundColorControl from "./BackgroundColorControl";

export default UgcBackgroundColorControl;
